/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  openManually: {
    defaultMessage: 'Open BankID',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.openManually',
  },
  connectInstructions: {
    defaultMessage: 'Open Mobile BankID app and log in to connect {providerName} to {clientName}',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.connectInstructions',
  },
  paymentInstructions: {
    defaultMessage: 'Open Mobile BankID to sign the payment',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.paymentInstructions',
  },
  accountsInstructions: {
    defaultMessage: 'Open Mobile BankID and log in to retrieve your accounts list',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.accountsInstructions',
  },
  heading: {
    defaultMessage: 'Open the BankID app',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.heading',
  },

  authorizeHeader: {
    defaultMessage: 'Waiting for authentication',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.authorizeHeader',
  },
  paymentHeader: {
    defaultMessage: 'Waiting for payment to be signed',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.paymentHeader',
  },
  instructions: {
    defaultMessage: 'To continue, follow the instructions in the Mobile BankID app',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.instructions',
  },
  bankIDinfo: {
    defaultMessage: "Can't see the Mobile BankID app?",
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.bankIDinfo',
  },
  retry: {
    defaultMessage: 'Click to open',
    id: 'AwaitingMobileBankIdAuthenticationLocalPrompt.retry',
  },
});
